<template>
  <b-modal
      :id="id"
      centered
      footer-class="border-0 pt-0"
      hide-header
      no-close-on-backdrop
      no-close-on-esc
  >
    <div class="text-center py-2">
      <div class="d-flex justify-content-center mb-3">
        <img :src="AlertIcon" alt="Alert Icon" width="40" height="40" />
      </div>
      <h4>{{ loadErrorTitle }}</h4>
      <p class="m-0 text-muted">{{ loadErrorDescription }}</p>
    </div>
    <template #modal-footer>
      <div class="d-flex gap-3 w-100">
        <b-button class="w-50" variant="light" @click="handleBack">
          <b>{{ $t(closeOnly ? 'Close' : 'Back') }}</b>
        </b-button>
        <b-button v-if="retryable" class="w-50 m-0" variant="primary" @click="handleRetry">
          <b>{{ lodash.startCase($t('Retry')) }}</b>
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import AlertIcon from '@/assets/icons/AlertIcon.svg'

export default {
  name: 'sales-plan-load-error-dialog',
  props: {
    id: {default: 'sales-plan-load-error-dialog-modal'},
    closeOnly: {type: Boolean, default: false},
  },
  data() {
    return {
      AlertIcon,
      planId: null,
      customTitle: null,
      customDescription: null,
      retryable: true,
    }
  },
  computed: {
    loadErrorTitle() {
      if (this.customTitle) return this.customTitle

      const hasPlanId = this.planId !== null && this.planId !== undefined && `${this.planId}`.trim() !== ''
      const titleKey = hasPlanId ? 'load_error_title' : 'load_error_title_no_id'

      return this.$t(`sales_plans.modal_messages.${titleKey}`, {id: this.planId})
    },
    loadErrorDescription() {
      return this.customDescription || this.$t('sales_plans.modal_messages.load_error_description')
    },
  },
  methods: {
    show(planId = null) {
      this.planId = planId
      this.customTitle = null
      this.customDescription = null
      this.retryable = true
      this.$bvModal.show(this.id)
    },
    showMessage(title, description, retryable = true) {
      this.customTitle = title
      this.customDescription = description
      this.retryable = retryable
      this.$bvModal.show(this.id)
    },
    hide() {
      this.$bvModal.hide(this.id)
    },
    handleBack() {
      this.hide()
      if (!this.closeOnly) this.$emit('back')
    },
    handleRetry() {
      this.hide()
      this.$emit('retry')
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep {
  .modal-body {
    color: var(--neutral-gray-800, #454646);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
  }

  .modal-footer {
    border: none;
  }
}
</style>
